import { render, staticRenderFns } from "./AdicionarEquipe.vue?vue&type=template&id=53cf84fc&scoped=true"
import script from "./AdicionarEquipe.vue?vue&type=script&lang=js"
export * from "./AdicionarEquipe.vue?vue&type=script&lang=js"
import style0 from "./AdicionarEquipe.vue?vue&type=style&index=0&id=53cf84fc&prod&scoped=true&lang=scss"
import style1 from "./AdicionarEquipe.vue?vue&type=style&index=1&id=53cf84fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf84fc",
  null
  
)

export default component.exports